
import { Vue, Component, Prop } from "vue-property-decorator";
import StaticsContent from "./components/statics-content.vue";

@Component({
  components: {
    StaticsContent,
  },
})
export default class PaymentStatics extends Vue {
  activeName = "all";
}
